import { flexStyle, textStyle } from '@themes/mixins';
import { NavLink } from 'react-router-dom';
import styled, { css } from 'styled-components';

import Icon from '../../../Icon';

export const Root = styled.div`
  ${flexStyle({
    justify: 'space-between',
    direction: 'column',
    wrap: 'nowrap',
  })};
  width: 100%;
`;
export const IconAndTitleContainer = styled.div`
  ${flexStyle({
    align: 'center',
    justify: 'flex-start',
    direction: 'row',
    wrap: 'nowrap',
  })};
  height: 30px;
`;
export const NavLinkIcon = styled(Icon)`
  color: ${({ theme }) => theme.colors.textSecondary};
  margin-right: 8px;
  display: inline-block;
`;
export const ArrowIcon = styled(Icon)`
  color: ${({ theme }) => theme.colors.textSecondary};
  display: inline-block;
  padding: 3px;

  &:hover {
    background-color: #cad5e280;
    border-radius: 5px;
  }
`;
export const NavLinkTitle = styled.span`
  ${textStyle({
    color: 'textSecondary',
    lineHeight: 1,
    size: '12px',
    textAlign: 'left',
    weight: 400,
  })};
`;
export const NavLinkContainer = styled.div`
  ${flexStyle({
    align: 'center',
    justify: 'flex-start',
    direction: 'row',
    wrap: 'nowrap',
  })};
  width: 100%;
`;
export const StyledNavLink = styled(NavLink)<{
  $isActive: boolean;
  $subLevel?: number;
  $showDot?: boolean;
  $isOpenedNavBar?: boolean;
}>`
  ${flexStyle({
    align: 'center',
    justify: 'space-between',
    direction: 'row',
    wrap: 'nowrap',
  })};
  color: ${({ theme }) => theme.colors.textSecondary};
  width: 100%;
  text-decoration: none;
  padding: ${({ $subLevel }) => ($subLevel ? '8px 16px' : '7px 17px')};
  font-size: 14px;

  &:hover {
    background-color: ${({ theme }) => theme.colors.secondaryBackground};
    border-radius: 10px;

    & ${NavLinkTitle} {
      color: ${({ theme }) => theme.colors.textPrimary};
    }
    & ${NavLinkIcon} {
      color: ${({ theme }) => theme.colors.textPrimary};
    }
    & ${ArrowIcon} {
      color: ${({ theme }) => theme.colors.textPrimary};
    }
  }
  ${({ $subLevel }) =>
    $subLevel &&
    css`
      padding-left: ${$subLevel * 12 + 20}px;
    `}
  ${({ $isActive, $showDot, $isOpenedNavBar }) =>
    $isActive &&
    css`
      background-color: ${({ theme }) => theme.colors.secondaryBackground};
      border-radius: 10px;
      border-left: ${() => !$showDot && $isOpenedNavBar && '6px solid grey'};
      margin: 0px 2px;

      ${$showDot &&
      $isOpenedNavBar &&
      css`
        &::after {
          content: '';
          display: inline-block;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background-color: ${({ theme }) => theme.colors.textPrimary};
          flex-shrink: 0;
          margin-right: 4px;
        }
      `}

      & ${NavLinkTitle} {
        color: ${({ theme }) => theme.colors.textPrimary};
      }
      & ${NavLinkIcon} {
        color: ${({ theme }) => theme.colors.textPrimary};
      }
      & ${ArrowIcon} {
        color: ${({ theme }) => theme.colors.textPrimary};
      }
    `}
`;
export const SubMenuContainer = styled.div`
  ${flexStyle({
    align: 'center',
    justify: 'space-between',
    direction: 'column',
    wrap: 'nowrap',
  })};
  width: 100%;
  gap: 2px;
  margin-left: 30px; /* space for parent icon */
  border-left: 1px solid ${({ theme }) => theme.colors.divider};
`;

export const SubMenuNavLinkContainer = styled.div`
  ${flexStyle({
    align: 'center',
    justify: 'flex-start',
    direction: 'row',
    wrap: 'nowrap',
  })};
  width: 100%;
`;

export const SubMenuStyledNavLink = styled(NavLink)<{
  $isActive: boolean;
  $subLevel?: number;
}>`
  ${flexStyle({
    justify: 'space-between',
    direction: 'row',
    wrap: 'nowrap',
  })};
  color: ${({ theme }) => theme.colors.textSecondary};
  width: 100%;
  text-decoration: none;
  padding: 6px 14px;
  font-size: 14px;

  &:hover {
    background: ${({ theme }) => theme.colors.surfaceSecondary};
    border-radius: 10px;
    width: 70%;

    & ${NavLinkTitle} {
      color: ${({ theme }) => theme.colors.textPrimary};
    }
    & ${NavLinkIcon} {
      color: ${({ theme }) => theme.colors.textPrimary};
    }
    & ${ArrowIcon} {
      color: ${({ theme }) => theme.colors.textPrimary};
    }
  }
  ${({ $subLevel }) =>
    $subLevel &&
    css`
      padding-left: ${$subLevel * 12 + 20}px;
    `}
  ${({ $isActive }) =>
    $isActive &&
    css`
      border-left: 2px solid grey;

      & ${NavLinkTitle} {
        color: ${({ theme }) => theme.colors.textPrimary};
      }
      & ${NavLinkIcon} {
        color: ${({ theme }) => theme.colors.textPrimary};
      }
      & ${ArrowIcon} {
        color: ${({ theme }) => theme.colors.textPrimary};
      }
    `}
`;

export const SectionTitle = styled.div`
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.textSecondary};
  padding: 16px 20px 8px 20px;
  margin-top: 8px;
  user-select: none;
`;

export const IconWrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SectionDivider = styled.div`
  height: 1px;
  width: 100%;
  background: ${({ theme }) => theme.colors.divider};
  margin: 12px 0 4px 0;
`;
